import { defineStore } from 'pinia'
import { useJobOffersStore } from '@/stores/jobOffers'
import {useFilterStore} from "@/stores/filter";

export const useGlobalStore = defineStore('global', {
  state: () => ({
    loading: false,
    initialized: false,
    jobDetailBaseUrl: window.tx_jobs.job_offer_list.job_detail_base,
    pidQueryParam: window.tx_jobs.job_offer_list.pid_query_param
  }),
  getters: {},
  actions: {
    parseUrlParamToArray(params) {
      return params.split(',')
    },
    async setPredefinedFilter ()
    {
      const filterStore = useFilterStore()
      // get params from url
      const url = new URL(window.location.href)

      if (url.searchParams.has('location[in]')) {
        let locationUidParam = url.searchParams.get('location[in]')
        const locationUids = this.parseUrlParamToArray(locationUidParam)
        for (let i = 0; i < locationUids.length; i++) {
          if (!isNaN(locationUids[i])) {
            const locationUid = parseInt(locationUids[i])
            const title = filterStore.getLocationTitleWithUid(locationUid)
            if (title !== '') {
              filterStore.handleSelectedLocations({uid: locationUid, title: title})
            }
          }
        }
      }

      if (filterStore.preSelectedWorkField === '' && url.searchParams.has('workField[in]')) {
        let workFieldUidParam = url.searchParams.get('workField[in]')
        const workFieldUids = this.parseUrlParamToArray(workFieldUidParam)
        for (let i = 0; i < workFieldUids.length; i++) {
          if (!isNaN(workFieldUids[i])) {
            const workFieldUid = parseInt(workFieldUids[i])
            const title = filterStore.getWorkFieldTitleWithUid(workFieldUid)
            if (title !== '') {
              filterStore.handleSelectedWorkFields({uid: workFieldUid, title: title})
            }
          }
        }
      }

      if (url.searchParams.has('category[in]')) {
        let categoryUidParam = url.searchParams.get('category[in]')
        const categoryUids = this.parseUrlParamToArray(categoryUidParam)
        for (let i = 0; i < categoryUids.length; i++) {
          if (!isNaN(categoryUids[i])) {
            const categoryUid = parseInt(categoryUids[i])
            const title = filterStore.getCategoryTitleWithUid(categoryUid)
            if (title !== '') {
              filterStore.handleSelectedCategories({uid: categoryUid, title: title})
            }
          }
        }
      }

      if (url.searchParams.has('employment[contains]')) {
        let emplyomentUidParam = url.searchParams.get('employment[contains]')
        const employmentUids = this.parseUrlParamToArray(emplyomentUidParam)
        for (let i = 0; i < employmentUids.length; i++) {
          if (!isNaN(employmentUids[i])) {
            const employmentUid = parseInt(employmentUids[i])
            const title = filterStore.getEmploymentTitleWithUid(employmentUid)
            if (title !== '') {
              filterStore.handleSelectedEmployments({uid: employmentUid, title: title})
            }
          }
        }
      }

      if (url.searchParams.has('careerLevel[contains]')) {
        let careerLevelUidParam = url.searchParams.get('careerLevel[contains]')
        const careerLevelUids = this.parseUrlParamToArray(careerLevelUidParam)
        for (let i = 0; i < careerLevelUids.length; i++) {
          if (!isNaN(careerLevelUids[i])) {
            const careerLevelUid = parseInt(careerLevelUids[i])
            const title = filterStore.getCareerLevelTitleWithUid(careerLevelUid)
            if (title !== '') {
              filterStore.handleSelectedCareerLevels({uid: careerLevelUid, title: title})
            }
          }
        }
      }

      if (url.searchParams.has('title[like]')) {
        let searchQuery = url.searchParams.get('title[like]')
        if (searchQuery.replaceAll('%', '') !== '') {
          filterStore.setSearchQueryInput(searchQuery.replaceAll('%', ''))
        }
      }
    },
    buildParamsStringFromUids(uidArr) {
      let string = ''
      for (let i = 0; i < uidArr.length; i++) {
        string = string + uidArr[i]
        if ((i+1) < uidArr.length) {
          string = string + ','
        }
      }
      return string
    },
    pushStateToUrl() {
      const filterStore = useFilterStore()
      const url = new URL(window.location.href)

      const selectedLocationUids = filterStore.getSelectedLocationUids()
      if (selectedLocationUids.length > 0) {
        url.searchParams.set('location[in]', this.buildParamsStringFromUids(selectedLocationUids))
      } else if (url.searchParams.has('location[in]')) {
        url.searchParams.delete('location[in]')
      }

      const selectedWorkFieldUids = filterStore.getSelectedWorkFieldUids()
      if (selectedWorkFieldUids.length > 0) {
        url.searchParams.set('workField[in]', this.buildParamsStringFromUids(selectedWorkFieldUids))
      } else if (url.searchParams.has('workField[in]')) {
        url.searchParams.delete('workField[in]')
      }

      const selectedCategoryUids = filterStore.getSelectedCategoryUids()
      if (selectedCategoryUids.length > 0) {
        url.searchParams.set('category[in]', this.buildParamsStringFromUids(selectedCategoryUids))
      } else if (url.searchParams.has('category[in]')) {
        url.searchParams.delete('category[in]')
      }

      const selectedEmploymentUids = filterStore.getSelectedEmploymentUids
      if (selectedEmploymentUids.length > 0) {
        url.searchParams.set('employment[contains]', this.buildParamsStringFromUids(selectedEmploymentUids))
      } else if (url.searchParams.has('employment[contains]')) {
        url.searchParams.delete('employment[contains]')
      }

      const selectedCareerLevelUids = filterStore.getSelectedCareerLevelUids()
      if (selectedCareerLevelUids.length > 0) {
        url.searchParams.set('careerLevel[contains]', this.buildParamsStringFromUids(selectedCareerLevelUids))
      } else if (url.searchParams.has('careerLevel[contains]')) {
        url.searchParams.delete('careerLevel[contains]')
      }

      const searchQuery = filterStore.searchQueryInput
      if (searchQuery !== '') {
        url.searchParams.set('title[like]', '%' + searchQuery + '%')
      } else if (url.searchParams.has('title[like]')) {
        url.searchParams.delete('title[like]')
      }

      window.history.pushState({}, '', url)

    },
    async init ()
    {
      this.loading = true
      const jobOfferStore = useJobOffersStore()
      await jobOfferStore.initAllFilters()
      await this.setPredefinedFilter()
      await jobOfferStore.getAllRelevantJobOffers()
      this.initialized = true
      this.loading = false
    }
  }
})
